import React from 'react';

const PromoBanner = () => {

  const tabletBanner = '/assets/qinto_banner_728.png';
  const laptopBanner = '/assets/qinto_banners_1440.png';
  const desktopBanner = '/assets/qinto_download_banner_1920.png';
  const mobileBanner = '/assets/qinto_download_Square_Banner.png';

  return (
    <div className="w-full max-w-[1920px] mx-auto cursor-pointer" onClick={() => window.open('https://play.google.com/store/apps/details?id=com.qinto.qintoapp', '_blank')}>
      <picture>
        {/* 1. Ultra-Wide Desktop: Screens 1440px and wider (Shows 1920px banner) */}
        <source media="(min-width: 1440px)" srcSet={desktopBanner} />

        {/* 2. MacBooks & Laptops: Screens between 1024px and 1439px (Shows 1440px banner) */}
        <source media="(min-width: 1024px)" srcSet={laptopBanner} />

        {/* 3. Tablets/iPads: Screens between 768px and 1023px (Shows 728px banner) */}
        <source media="(min-width: 768px)" srcSet={tabletBanner} />

        {/* 3. Mobile Fallback: Screens smaller than 768px (Shows the 1200x1200px square banner) */}
        <img
          onClick={(e) => { e.stopPropagation(); window.open('https://play.google.com/store/apps/details?id=com.qinto.qintoapp', '_blank'); }}
          src={mobileBanner}
          alt="Download the Qinto App today for free featured listings!"
          style={{ width: '100%', height: 'auto', display: 'block' }}
          loading="lazy"
        />
      </picture>
    </div>
  );
};

export default PromoBanner;